var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVimeo14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3.325 6.332s.67-.53.893-.265c.224.265 1.076 3.463 1.361 4.053.249.517.934 1.2 1.685.712s3.25-2.626 3.696-5.152c.447-2.524-3.005-1.996-3.371.204.914-.55 1.402.224.934 1.1-.467.875-.893 1.446-1.117 1.446s-.394-.586-.65-1.61c-.264-1.058-.262-2.965-1.36-2.749C4.361 4.275 3 5.905 3 5.905z"
}))));
export default SvgChannelVimeo14;